module.exports = __webpack_public_path__ + "img/logo-small.4a3c8c5b.png";